/**
 * The AsyncComponent is used to dynamically load components at run time
 *
 * @module views/__core/AsyncComponent/AsyncComponent
 */
import React from 'react';
import LoadableComponent from '../../components/LoadableComponent/LoadableComponent'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';


export const isComponentValid = componentName => {
  const exclusionList = ['DataCapturePageMetaData'];
  return exclusionList.filter( currentComponent => currentComponent === componentName ).length === 0;
}

export const AsyncComponent = function( props = {} ){
  if( !props.moduleName && props.modules ){
    return props.modules.map( ( i, index )=> {
      return (
        <ErrorBoundary
          key={ `${i.id}:${index}` }
        >
          <AsyncComponent
            { ...i }
          />
        </ErrorBoundary>
      )
    } );
  }
  if( ( props.moduleName && isComponentValid( props.moduleName ) ) || props?.meta?.initAction ){
    return (
      <ErrorBoundary>
        <LoadableComponent { ...props } />
      </ErrorBoundary>
    );
  }
  return true;
}

export default AsyncComponent;
